import { useContext } from 'react'
import { AppContext, AppContextType } from '../../AppContext'
import ScreenControlDiagnosticsPage from './ScreenControlDiagnosticsPage'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'

export default function ScreenControlDiagnosticsModalController() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    if (appState.appState.showScreenControlDiagnosticsPage) {
        return (
            <CrossPlatformDialog
                frameName="Dialog:ScreenControlDiagnostics"
                classNameNative="md:w-[1000px]"
                onDefaultClose={() => {
                    appDispatch({ type: 'update_app_state', value: { showScreenControlDiagnosticsPage: false } })
                }}
            >
                <ScreenControlDiagnosticsPage />
            </CrossPlatformDialog>
        )
    } else {
        return null
    }
}
